import toast from "react-hot-toast";
import { apiConnector } from "../apiconnector";
import { siteContentEndpoints } from "../apis";

export const getSiteContent = async (key) => {
  try {
    const response = await apiConnector("GET", `${siteContentEndpoints.GET}/${key}`);
    return response?.data?.data ?? null;
  } catch (error) {
    console.error("SITE_CONTENT_GET", error);
    return null;
  }
};

export const updateSiteContent = async (key, value, token) => {
  try {
    const response = await apiConnector(
      "PUT",
      `${siteContentEndpoints.UPDATE}/${key}`,
      { value },
      { Authorization: `Bearer ${token}` }
    );
    toast.success("Page content updated");
    return response?.data?.data ?? null;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Could not update page content");
    return null;
  }
};
